import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The teacher burns out first.",
    body:
      "Two to four hours to make one paper. Nights lost to grading. Repetitive questions from students who never learnt to work independently. The load compounds — and something breaks.",
    tag: "The staff-room problem",
  },
  {
    n: "02",
    title: "The student was never taught how to study.",
    body:
      "They re-read. They highlight. Neither works. They memorise answers, freeze when the question is framed differently, and lose focus after twenty minutes with no strategy to hold it.",
    tag: "The desk problem",
  },
  {
    n: "03",
    title: "The parent finds out last.",
    body:
      "A report card in March, a shocked call, a scramble for tuitions. No visibility, no early signal, no plain-language weekly summary of what actually happened at school this week.",
    tag: "The dinner-table problem",
  },
  {
    n: "04",
    title: "AI, done right, makes students think harder — not less.",
    body:
      "ProBodh never gives answers away. Every module is engineered around Pre-testing, Active Recall and Metacognitive Reflection. The design test is simple: if a step feels effortless, the AI is in the wrong place.",
    tag: "Our design principle",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative bg-cream py-16 md:py-24"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        <div className="max-w-3xl mb-10 md:mb-14">
          <div className="text-[12px] md:text-[13px] uppercase tracking-[0.18em] text-ink-muted font-semibold">
            Manifesto
          </div>
          <h2 className="mt-3 md:mt-4 font-display text-3xl sm:text-4xl md:text-5xl leading-[1.05] text-ink tracking-tight">
            Do these problems sound familiar?{" "}
            <span className="font-italic-serif text-ink">
              ProBodh solves them for you.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {chapters.map((ch, i) => (
            <motion.article
              key={ch.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-2xl md:rounded-3xl bg-off border border-line-soft p-6 md:p-8 hover:-translate-y-1 transition-transform duration-500"
              data-testid={`manifesto-chapter-${ch.n}`}
            >
              <div className="flex items-baseline gap-4 mb-4 md:mb-5">
                <span className="font-display text-4xl md:text-5xl text-accent leading-none">
                  {ch.n}
                </span>
                <span className="text-[11px] md:text-[12px] uppercase tracking-[0.16em] text-ink-muted font-semibold">
                  {ch.tag}
                </span>
              </div>
              <h3 className="font-display text-xl md:text-2xl leading-tight text-ink max-w-[24ch]">
                {ch.title}
              </h3>
              <p className="mt-3 md:mt-4 text-[14px] md:text-[15px] leading-relaxed text-ink-soft">
                {ch.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
